import {
  WorksOrderStakeholdersInterface,
  IdRef,
} from '../../types';

export const getClient = (
  orderStakeholders: WorksOrderStakeholdersInterface,
  orderStakeholderIds: IdRef[],
) => {
  const clients = orderStakeholderIds.map((id) => orderStakeholders?.[id])
    .filter((stakeHolder) => stakeHolder?.isClient);
  if (clients.length === 0) return null;
  return clients[0];
};
